import React, { ReactNode } from 'react'
import Paper from '@mui/material/Paper'
import { useTranslation } from 'react-i18next'
import { useFilterBarStyles } from './FilterBar.styles'

interface FilterBarProps {
    filter: ReactNode
    chips: ReactNode
    children?: ReactNode
    showBarContainer?: boolean
    layout?: 'default' | 'reversed'
}

const FilterBar: React.FC<FilterBarProps> = (props) => {
    const {
        children,
        filter,
        chips,
        layout = 'default',
        showBarContainer = true
    } = props
    const { t } = useTranslation('filter')
    const styles = useFilterBarStyles()

    const filterContent = (
        <>
            {layout === 'default' ? (
                <div>
                    {filter}
                    {chips}
                </div>
            ) : (
                <div>
                    {chips}
                    {filter}
                </div>
            )}
            {children ? (
                <>
                    <div className={styles.or}>{t('filter.or')}</div>
                    {children}
                </>
            ) : null}
        </>
    )

    return showBarContainer ? (
        <Paper className={styles.container}>{filterContent}</Paper>
    ) : (
        filterContent
    )
}

export default FilterBar
